import { store } from '@core/Store'
import { selectPlayerSessionId } from '@core/Areas/KambiClient/Store/selectors'
import { simpleFetch } from '@core/Utils/fetch/simpleFetch'

export const getFromKambiPlayerApi = async <T>({
  urlPath,
}: {
  urlPath: string
}): Promise<T | null> => {
  const playerSessionId = selectPlayerSessionId(store.getState())

  if (!playerSessionId) return null

  try {
    const response = await simpleFetch<T>(`${window._kc.apiPlayerBaseUrl}${urlPath}`, {
      headers: { authorization: `Bearer ${playerSessionId}` },
    })

    return response
  } catch {
    return null
  }
}
